import enMessages from "./en.json";

const messages = {
  en: {
    ...enMessages,
  },
};

export default messages;
